// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { setAuthorization } from "../helpers/api_helper";
// // import { useDispatch } from "react-redux";
// import { useProfile } from "../Components/Hooks/UserHooks";
// import { logoutUser } from "../slices/auth/login/thunk";
// import { useAppDispatch } from "../store/hooks";


// const AuthProtected = ({ children }: { children: React.ReactNode }) => {
//   const dispatch = useAppDispatch();


//   const { isAuthenticated, loading } = useProfile();

//   console.log(isAuthenticated)

//   const [shouldRedirect, setShouldRedirect] = useState(false);
//   console.log("condition......",isAuthenticated, loading)

//   useEffect(() => {
//     if (!loading && !isAuthenticated) {
//       dispatch(logoutUser());
//       setShouldRedirect(true);
//     }
//   }, [loading, isAuthenticated, dispatch]);

//   if (shouldRedirect) {
//     return <Navigate to="/login" replace />;
//   }

//   return <>{children}</>;
// };

// export default AuthProtected;




import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchLoggedInUser } from "services/authServcies";
import { fetchUserPermissions } from "slices/auth/login/thunk";

const AuthProtected = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, loading, permissions } = useAppSelector((state) => state.Login);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const authUser = sessionStorage.getItem("authUser");
    if (!authUser) {
      setHydrated(true);
      return;
    }
    if (isAuthenticated) {
      setHydrated(true);
      return;
    }
    dispatch(fetchLoggedInUser()).finally(() => setHydrated(true));
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && permissions.length === 0 && sessionStorage.getItem("authUser")) {
      dispatch(fetchUserPermissions());
    }
  }, [dispatch, isAuthenticated, permissions.length]);

  if (!isAuthenticated && !sessionStorage.getItem("authUser")) {
    return <Navigate to="/login" replace />;
  }

  if (!hydrated || loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary mb-2" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mb-0">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;

